import { FC } from 'react';
import { TextLink } from '@bfe/moly';
import { useFm, useScreenType } from '@web3/base-hooks';
import { openLink, isNlSite } from '@web3/base-utils';
import styles from './index.module.scss';

import Telegram from '@/assets/Telegram.svg';
import Twitter from '@/assets/Twitter.svg';

interface JoinContainerProps {}

export const JoinContainer: FC<JoinContainerProps> = () => {
  const fm = useFm();
  const { isMobile } = useScreenType();

  const size = {
    textLink: isMobile ? 'normal' : 'large',
  };

  const navToMedia = (link: string) => {
    if (isMobile) {
      openLink(link);
      return;
    }
    window.open(link, '_blank');
  };

  return (
    <div className={styles.joinBox}>
      <div className={styles.header}>
        <div className={styles.title}>{fm('joinBybitWeb3')}</div>
      </div>

      <div className={styles.body}>
        <div className={styles.card}>
          <div className={styles.header}>
            <div className={styles.t1}>{fm('joinOurCommunity')}</div>
            <div className={styles.t2}>{fm('joinOurCommunityDesc')}</div>
          </div>
          <div className={styles.footer}>
            <div className={styles.actions}>
              <div
                className={styles.social}
                rel="noreferrer"
                onClick={() =>
                  navToMedia(
                    isNlSite()
                      ? 'https://t.me/satos_official'
                      : 'https://t.me/BybitEnglish'
                  )
                }
              >
                <Telegram className={styles.icon} />
                <div className={styles.text}>Telegram</div>
              </div>
              <div
                className={styles.social}
                rel="noreferrer"
                onClick={() => navToMedia('https://twitter.com/Bybit_Web3')}
              >
                <Twitter className={styles.icon} />
                <div className={styles.text}>Twitter</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.header}>
            <div className={styles.t1}>{fm('buildWithUs')}</div>
            <div className={styles.t2}>{fm('partnerSolutions')}</div>
          </div>
          <div className={styles.footer}>
            <div className={styles.list}>
              <div className={styles.desc}>
                <TextLink
                  size={size.textLink}
                  variant="secondary"
                  opensWindow
                  onClick={() => {
                    navToMedia(
                      'https://uponly.larksuite.com/share/base/form/shrusiQ3FwkuwGiDcR933kq5lAc'
                    );
                  }}
                >
                  {fm('integrateBybitWallet')}
                </TextLink>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.header}>
            <div className={styles.t1}>{fm('partnerWithUs')}</div>
            <div className={styles.t2}>{fm('collabForInnovBlockSol')}</div>
          </div>
          <div className={styles.footer}>
            <div className={styles.list}>
              <div className={styles.desc}>
                <TextLink
                  size={size.textLink}
                  variant="secondary"
                  opensWindow
                  onClick={() => {
                    navToMedia(
                      'https://uponly.larksuite.com/share/base/form/shrusE6TYZJGVBO9LOCWCICiWvb'
                    );
                  }}
                >
                  {fm('listingPartnership')}
                </TextLink>
              </div>
              <div className={styles.desc}>
                <TextLink
                  size={size.textLink}
                  variant="secondary"
                  opensWindow
                  onClick={() => {
                    navToMedia(
                      'https://uponly.larksuite.com/share/base/form/shrusy12cnDPuKJV2JDimh1qvjb'
                    );
                  }}
                >
                  {fm('dAppStoreListing')}
                </TextLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
